module.exports = __webpack_public_path__ + "img/pioneer.d10f1b02.jpg";